import { FC, forwardRef, useCallback, useState } from 'react'
import { View } from 'react-native'
import { IconButton } from 'react-native-paper'
import { OrderColorEnum, orderColorNameDictionary } from '../../../constants/colors'
import { useAppDispatch } from '../../../hooks/redux'
import { setOrderColor } from '../../../redux/reducers/order/action-creators'
import { performHaptics } from '../../../utils/performHaptics'
import Menu from '../../UI/Menu/Menu'
import MenuItem from '../../UI/Menu/MenuItem'

const PaletteButton = forwardRef<View, { onPress: () => void }>(function PaletteButton(
    { onPress },
    ref
) {
    return (
        <IconButton
            icon="palette"
            iconColor="#000000"
            size={38}
            onPress={onPress}
            style={{ position: 'absolute', top: -12, left: 0 }}
            ref={ref}
        />
    )
})

interface OrderColorMenuProps {
    orderKey: string
}

const OrderColorMenu: FC<OrderColorMenuProps> = ({ orderKey }) => {
    const dispatch = useAppDispatch()

    const [open, setOpen] = useState(false)

    const handlePress = useCallback(() => {
        performHaptics()

        setOpen(true)
    }, [])

    const handleDismiss = () => {
        setOpen(false)
    }

    const handleMenuItemPress = (color: OrderColorEnum) => {
        handleDismiss()

        dispatch(setOrderColor({ orderKey, color }))
    }

    return (
        <Menu open={open} onPress={handlePress} onDismiss={handleDismiss} Button={PaletteButton}>
            {Object.values(OrderColorEnum).map((color) => (
                <MenuItem key={color} onPress={() => handleMenuItemPress(color)}>
                    <View
                        style={{ backgroundColor: color, borderRadius: 8, height: 16, width: 16 }}
                    />{' '}
                    {orderColorNameDictionary[color]}
                </MenuItem>
            ))}
        </Menu>
    )
}

export default OrderColorMenu
